import Cookies from 'js-cookie'

document.addEventListener("DOMContentLoaded", function() {

	document.addEventListener('click', function (event) {

		if (!event.target.matches('input[name="delivery-type"]')) return;

		let delivery_type = (event.target).getAttribute('id');

        if ( delivery_type == 'cart-fitted' ) {

			//change our variable to a nicer name
			delivery_type = 'branch_fitting';
        } else if ( delivery_type == 'cart-delivered' ) {

			//change our variable to a nicer name
			delivery_type = (cart_ajax_object.delivery_allowed == 'true') ? 'home_delivery' : 'branch_fitting';
        }

		//if we still have a delivery type name
		if(delivery_type) {

			//set the cookie indicating their preference
			Cookies.set('bt_fulfillment_type', delivery_type, { expires: 1 });

			document.body.dataset.fulfilment_type = delivery_type;
		}

	}, false);

	//check to see if we have a cookie to read from
	let fulfillment_type = Cookies.get('bt_fulfillment_type');

	//if we have something
	if(fulfillment_type) {

		//attempt to fetch the HTML radio button
		let target = document.getElementById('cart-' + fulfillment_type);

		//if we've found the button
		if(target) {

			//check this option
			target.checked = true;
		}
	}
});